import { WebSocketSubject } from './WebSocketSubject';
export var webSocket = WebSocketSubject.create;
//# sourceMappingURL=webSocket.js.map